import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationDataProvider } from '../configuration-data-provider';
import { SharedDataProvider } from '../shared-data-provider';
import {Stock, InventoryResult} from '../dto/stock';

/*
  Generated class for the StockProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class StockProvider {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  private getAuthHeader(): any {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-pePeLo-Auth': JSON.stringify(this.shared.getTokenAuthData())
    });
    return headers;
  }

  constructor(private http: HttpClient, private config: ConfigurationDataProvider, private shared: SharedDataProvider) { }

  /**
   * List all stocks which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.stockURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(stock : Stock) {
    console.log('Push stock to insert method of service.');
    stock.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(stock));
    return this.http.post(this.config.stockURL+"new", JSON.stringify(stock), {headers: this.headers});
  }

  public update(stock : Stock) {
    console.log('Push stock to update method of service.');
    stock.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(stock));
    return this.http.put(this.config.stockURL+"id/"+stock.id, JSON.stringify(stock), {headers: this.headers});
  }

  public qryStock(id : number) {
    return this.http.post(this.config.stockURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete stock '+ id);
    return this.http.post(this.config.stockURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public load(first : number, pageSize: number, sortField : string, sortOrder: string, filterSet : any) {
    let paramSet : any = {};
    paramSet.credentials = this.shared.getTokenAuthData();
    paramSet.first = first;
    paramSet.pageSize = pageSize;
    paramSet.sortField = sortField;
    paramSet.sortOrder = sortOrder;
    paramSet.filters = filterSet;

    console.log("Load stocks filtered: "+JSON.stringify(paramSet));

    return this.http.post(this.config.stockURL+"filter", JSON.stringify(paramSet), {headers: this.headers});
  }

  public bookInventoryResult(result : InventoryResult) {
    result.credentials = this.shared.getTokenAuthData();
    return this.http.post(this.config.stockURL+"bookinventorycount", JSON.stringify(result), {headers: this.getAuthHeader()});
  }
}



// WEBPACK FOOTER //
// ./src/providers/stock/stock.ts